<div class="photo-preview-container">
  <button 
    mat-icon-button 
    class="close-button" 
    (click)="onClose()" 
    aria-label="Cerrar">
    <mat-icon fontSet="material-icons-outlined">close</mat-icon>
  </button>
  
  <div class="image-container">
    <img 
      [src]="data.imageUrl" 
      [alt]="data.alt || 'Vista previa de imagen'"
      class="preview-image" />
  </div>
</div>
